import React from "react";
import GeneralImage, { GeneralImageProps } from "../GeneralImage";
import "./avatar.css";

interface IAvatar extends GeneralImageProps {
  FullName?: string;
  Id?: number;
  size?: "very-small" | "small" | "medium" | "large" | "very-large";
}

const ProfileAvatar: React.FC<IAvatar> = ({
  src,
  FullName,
  Id,
  size,
  className,
  imageToLoad,
  withPreview, 
  ...props
}) => { 
  const getFirstLetters = `${FullName?.split(" ")?.[0]?.[0]}`;
  const getColorFromId = (id: string) => {
    const colors = ["green", "purple", "orange", "blue"];
    let hash = 0;

    for (let i = 0; i < id.length; i++) {
      hash = (hash * 31 + id.charCodeAt(i)) % 1000;
    }

    return colors[hash % colors.length];
  };
  return (
    <div className={`avatar ${className} overflow-hidden`}>
      {src || !FullName ? (
        <GeneralImage
          src={src}
          withPreview={withPreview}
          className={className}
          imageToLoad={imageToLoad} 
          {...props}
        />
      ) : (
        <div
          className={`avatar-${Id ? getColorFromId(String(Id)) : "blue"} ${size === "very-small" ? "text-xs" : size === "small" ? "text-base" : size === "medium" ? "text-xl" : size === "very-large" ? "text-5xl" : "text-2xl"} flex h-full w-full items-center justify-center rounded-lg bg-primaryLight font-bold text-primary`}
      
        >
          {getFirstLetters}
        </div>
      )}
    </div>
  );
};

export default ProfileAvatar;
